import  React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import workshop1 from "../static/img/workshop1.jpg";
import workshop2 from "../static/img/workshop2.jpg";
import workshop3 from "../static/img/workshop3.jpg";
import workshop4 from "../static/img/workshop4.jpg";
import workshop5 from "../static/img/workshop5.jpg";
import workshopPdf from '../static/file/Workshop.pdf';

import "./Microcredit.style.scss";

const OnlineWorkshop: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Online workshop «Launching CLP Do_learn»" : 
                "Онлайн-семінар «Запуск CLP Do_learn»"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? (<>
                        &nbsp; &nbsp;On October 29, 2026, the seminar "Launch of CLP Do_learn" took place as part of the Erasmus+ project "DOMANI."<br/>
                        &nbsp; &nbsp;The purpose of the seminar was to introduce Do_learn and explain the principles of how it works.<br/>
                        &nbsp; &nbsp;Moderators of seminar: <br/>
                        &nbsp; &nbsp;Anastasia Kleshch, <br/>
                        &nbsp; &nbsp;PhD (Geography), Associate Professor of the Department of Environmental Monitoring and Protected Areas Management, 
                        Karazin Institute of Environmental Sciences, Green Energy and Sustainable Development, V. N. Karazin 
                        Kharkiv National University (Kharkiv, Ukraine)<br/>
                        &nbsp; &nbsp;Yulia Yatsenko, <br/>
                        &nbsp; &nbsp;Assistant Professor of the Meteorology and Climatology Department, Faculty of Geography, 
                        Taras Shevchenko National University of Kyiv (Kyiv, Ukraine) <br/> 
                        &nbsp; &nbsp;The event program is available &nbsp;
                        <a href={workshopPdf} target="_blank" rel="noopener noreferrer" style={{color:"#3db166"}} >
                            HERE.
                        </a> 
                                            </>)
                    :
                    (<>
                        &nbsp; &nbsp;29 жовтня 2026 року в рамках проєкту Erasmus+ «DOMANI» відбувся семінар «Запуск CLP Do_learn».<br/>
                        &nbsp; &nbsp;Метою семінару було ознайомлення з Do_learn та пояснення принципів його роботи.<br/>
                        &nbsp; &nbsp;Модераторки семінару:<br/>
                        &nbsp; &nbsp;Анастасія Клещ,<br/>
                        &nbsp; &nbsp;кандидатка географічних наук, доцентка кафедри екологічного моніторингу та заповідної справи 
                        Навчально-наукового інституту екології, зеленої енергетики та сталого розвитку Харківського національного 
                        університету імені В. Н. Каразіна (Харків, Україна). <br/>
                        &nbsp; &nbsp;Юлія Яценко,<br/>
                        &nbsp; &nbsp;асистентка кафедри метеорології та кліматології географічного факультету Київського 
                        національного університету імені Тараса Шевченка (Київ, Україна);<br/>
                        &nbsp; &nbsp;Програма заходу можно переглянути &nbsp; 
                        <a href={workshopPdf} target="_blank" rel="noopener noreferrer" style={{color:"#3db166"}} >
                            ТУТ.
                        </a>
                    </>)
                }
            </p>
            {/*<p style={{textIndent: "2em"}}>*/}
            {/*    This is the second paragraph, which starts on a new line and also has an indent.*/}
            {/*</p>*/}
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px',width:"84%",margin:"0 auto"}}>
                <img src={workshop1} alt="workshop" style={{ width: '100%' }} />
                <img src={workshop2} alt="workshop" style={{ width: '100%',height:'100%' }} />
                <img src={workshop3} alt="workshop" style={{ width: '100%',height:'100%' }} />
                <img src={workshop4} alt="workshop" style={{ width: '100%',height:'100%' }} />
                <img src={workshop5} alt="workshop" style={{ width: '100%' }} />
            </div>
        </div>
    )
}
export default OnlineWorkshop;